import { EStatusProposta } from "#/enums";
import { DadosPropostaResponse } from "#/types";

export const MOCK_DADOS_PROPOSTA: DadosPropostaResponse = {
  proposta: {
    status: EStatusProposta.PROPOSTA_EM_ANALISE,
    numeroProposta: "4324829",
    produto: "Aliro M",
    seguradora: "Aliro Seguros",
    inicioVigencia: "2025-06-05",
    fimVigencia: "2026-06-05",
  },
  item: {
    modelo: "ONIX LT AT6 1.4 ECO FLEX 4P",
    placa: "FDL0H00",
    chassi: "9BGKS48V0JG391004",
  },
};

export const MOCK_DADOS_PROPOSTA_ERRO: DadosPropostaResponse = {
  proposta: {
    status: EStatusProposta.PROPOSTA_NAO_EFETIVADA,
    numeroProposta: "4324829",
    produto: "Aliro M",
    seguradora: "Aliro Seguros",
    inicioVigencia: "2025-06-05",
    fimVigencia: "2026-06-05",
  },
  item: {
    modelo: "ONIX LT AT6 1.4 ECO FLEX 4P",
    placa: "FDL0H00",
    chassi: "9BGKS48V0JG391004",
  },
};

export const MOCK_DADOS_PROPOSTA_APROVADA: DadosPropostaResponse = {
  proposta: {
    status: EStatusProposta.PROPOSTA_APROVADA,
    numeroProposta: "4324829",
    produto: "Aliro M",
    seguradora: "Aliro Seguros",
    inicioVigencia: "2025-06-05",
    fimVigencia: "2026-06-05",
  },
  item: {
    modelo: "ONIX LT AT6 1.4 ECO FLEX 4P",
    placa: "FDL0H00",
    chassi: "9BGKS48V0JG391004",
  },
};
